// dependencies
import Cookies from "js-cookie";
import { replace } from "yarrr";

// actions
import { changeEnvironment } from "Actions/app";

export const logout = () => (dispatch) => {
	Cookies.remove("logan-auth-token");
	dispatch({ type: "APP:LOGOUT" });

	dispatch(replace("/login/"));
};

export const storeToken = (token) => (dispatch) => {
	dispatch({ type: "APP:AUTHTOKEN.SAVE", token });
};

export const setUserRoles = (roles) => (dispatch) => {
	dispatch({ type: "APP:USER.ROLES", roles });
};

export const setUserEnvironmentPrivilege = (environments) => (dispatch) => {
	dispatch({ type: "APP:USER.ALLOWEDENVIRONMENTS", environments });

	if (environments.indexOf("production") === -1) {
		dispatch(changeEnvironment(environments[0]));
	}
};

export const setupAuthenticatedEnvironment = () => (dispatch) => {
	const loganToken = Cookies.get("logan-auth-token");
	const parsedToken = JSON.parse(atob(loganToken));

	dispatch(storeToken(loganToken));
	dispatch(setUserRoles(parsedToken.roles));
	dispatch(setUserEnvironmentPrivilege(parsedToken.environments));

	dispatch({ type: "APP:AUTHENTICATED" });
};
